import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import React from 'react';
import { calculatePercentage } from '../../lib/utils.js';
import AuthorizedAction from '../AuthorizedAction.js';
import SubHeader from '../SubHeader.jsx';
import styles from './ParticipationsHeader.module.css';

const ChangeInsightsParticipationsHeader = ({
  title,
  initiative,
  initiativeParticipation,
  resultsCount,
  initiativeParticipations,
}) => {
  const sumCounts = (group) => {
    let totalLeavesSurveyCount = group.leavesSurveyCount || 0;
    let totalLeavesSurveyCompletedCount = group.leavesSurveyCompletedCount || 0;

    if (group.children && group.children.length > 0) {
      group.children.forEach((child) => {
        const { leavesSurveyCount, leavesSurveyCompletedCount } =
          sumCounts(child);
        totalLeavesSurveyCount += leavesSurveyCount;
        totalLeavesSurveyCompletedCount += leavesSurveyCompletedCount;
      });
    }

    return {
      leavesSurveyCount: totalLeavesSurveyCount,
      leavesSurveyCompletedCount: totalLeavesSurveyCompletedCount,
    };
  };

  let count = 0;
  let completedCount = 0;

  if (initiativeParticipation) {
    count = initiativeParticipation.leavesSurveyCount;
    completedCount = initiativeParticipation.leavesSurveyCompletedCount;
  } else {
    initiativeParticipations.forEach((group) => {
      const { leavesSurveyCount, leavesSurveyCompletedCount } =
        sumCounts(group);
      count += leavesSurveyCount;
      completedCount += leavesSurveyCompletedCount;
    });
  }

  return (
    <SubHeader flexJustify small>
      <div className="flex flex-1" style={{ height: '36px' }}>
        <h2>{title}</h2>
        <strong className="header-item bordered text-muted">
          Current Level&nbsp;:&nbsp;
          <span className="text-primary">
            {resultsCount} {pluralize('Result', resultsCount)}
          </span>
        </strong>
        {initiative.project.manageProjectEntities &&
        resultsCount &&
        initiativeParticipations.length ? (
          <AuthorizedAction action="update" subject="changeImpact">
            <strong
              className={`header-item ${styles.completion} bordered text-muted`}
            >
              Completed:&nbsp;
              <span className="text-primary">
                {calculatePercentage(completedCount, count)}%
              </span>
              <span className="text-primary">
                {completedCount}/{count}
              </span>
            </strong>
          </AuthorizedAction>
        ) : null}
      </div>
    </SubHeader>
  );
};

ChangeInsightsParticipationsHeader.propTypes = {
  initiative: PropTypes.shape({
    completionTracked: PropTypes.bool,
    groupParticipationSurveyCount: PropTypes.number.isRequired,
    groupParticipationCompletedSurveyCount: PropTypes.number.isRequired,
  }).isRequired,
  initiativeParticipation: PropTypes.shape({
    leavesSurveyCount: PropTypes.number.isRequired,
    leavesSurveyCompletedCount: PropTypes.number.isRequired,
  }),
  resultsCount: PropTypes.number.isRequired,
};

export default ChangeInsightsParticipationsHeader;
